import { render, staticRenderFns } from "./tiaoli.vue?vue&type=template&id=84657460&scoped=true&"
import script from "./tiaoli.vue?vue&type=script&lang=js&"
export * from "./tiaoli.vue?vue&type=script&lang=js&"
import style0 from "./tiaoli.vue?vue&type=style&index=0&id=84657460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84657460",
  null
  
)

export default component.exports